export default __webpack_public_path__ + "components/bike-park-header/static/icon--heart-43fc22977a2724f885776f91ca49a0cb.svg";